// extracted by mini-css-extract-plugin
export default {"collectionLink":"My3hH"};